// A short divider between columns, inset from the top and bottom of the cell. Drawn as a
// pseudo-element so it takes no width and leaves the column sizes alone. The last column has none.
export const columnDividerSx = (color: string) => ({
  position: 'relative' as const,
  '&:not(:last-of-type)::after': {
    content: '""',
    position: 'absolute',
    right: 0,
    top: '25%',
    height: '50%',
    width: '1px',
    backgroundColor: color,
  },
})
